var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgenda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 117,
    viewBox: "0 0 91 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 91,
    height: 103,
    rx: 7,
    fill: "#FEF8F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 17.134 3.13401 14 7 14H84C87.866 14 91 17.134 91 21V45H0V21Z",
    fill: "#E34919"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 23.5V3",
    stroke: "#FEF8F7",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65 23.5V3",
    stroke: "#FEF8F7",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.776 96.576C28.144 96.576 23.68 92.352 23.68 85.104H29.296C29.296 89.472 31.648 91.92 35.776 91.92C39.184 91.92 41.488 89.808 41.488 86.688C41.488 83.136 39.424 81.312 35.344 81.312H33.04V76.56H35.392C38.896 76.56 40.624 74.976 40.624 71.76C40.624 69.168 38.56 67.344 35.584 67.344C32.08 67.344 29.92 69.456 29.92 73.008H24.496C24.496 66.768 28.816 62.784 35.584 62.784C41.968 62.784 46.24 66.384 46.24 71.76C46.24 75.216 44.32 77.664 40.72 78.816C44.56 79.488 47.056 82.56 47.056 86.64C47.056 92.496 42.4 96.576 35.776 96.576ZM63.064 96H57.592V73.536H50.68V68.928C56.776 68.928 58.072 67.392 58.072 63.36H63.064V96Z",
    fill: "#89A2B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgenda);
export default __webpack_public_path__ + "static/media/Agenda.c555d8d5cdb3174d55ad1564e16b1886.svg";
export { ForwardRef as ReactComponent };